/**
 * Хранит store для доступа вне компонентов
 *
 * Изначально пустое
 */

let store = null

export const getStore = () => store
export const setStore = props => {
  const { createStore } = props
  const nextCreateStore = (...args) => {
    const newStore = createStore(...args)
    store = newStore
    return newStore
  }
  return {
    createStore: nextCreateStore,
  }
}
